import Dashboard from "../../../../assets/Dashboard";
import Files from "../../../../assets/Files";
import Clients from "../../../../assets/Clients";
import Chat from "../../../../assets/Chat";
import Setting from "../../../../assets/Setting";
import Disc from "../../../../assets/Disc";
import Reports from "../../../../assets/Reports";
import Payments from "../../../../assets/Payments";
import ActivityIcon from "../../../../assets/ActivityIcon";

const sidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard", "/"],
  },
  {
    title: "Services",
    icon: <Files />,
    url: "/services",
    activeUrl: ["/services", "/file"],
  },
    {
    title: "Clients",
    icon: <Clients />,
    url: "/clients",
    activeUrl: ["/clients", "/client_details"],
  },
  {
    title: "Payments",
    icon: <Payments />,
    url: "/payments_report",
    activeUrl: ["/payments_report"],
  },
  {
    title: "Chat",
    icon: <Chat />,
    url: "/communication",
    activeUrl: ["/communication"],
  },
  {
    title: "Activity",
    icon: <ActivityIcon />,
    url: "/activity",
    activeUrl: ["/activity"],
  },
  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: ["/report/files"],
    children: [
      {
        title: "Services",
        icon: <Disc />,
        url: "/files_report",
        activeUrl: ["/files_report"],
      },
      {
        title: "Invoice",
        icon: <Disc />,
        url: "/invoice_report",
        activeUrl: ["/invoice_report"],
      },
      {
        title: "Signature",
        icon: <Disc />,
        url: "/signature_report",
        activeUrl: ["/signature_report"],
      },
    ],
  },
  {
    title: "Settings",
    icon: <Setting />,
    activeUrl: ["/tags"],
    children: [
      {
        title: "Site Settings",
        icon: <Disc />,
        url: "/settings",
        activeUrl: ["/settings"],
      },
    ],
  },
];

export default sidebarData;
